/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanTimelineEntryPointEntrypointProps } from './PlanTimelineEntryPoint.entrypoint.types.tsx';

type PlanTimelineEntryPointComponent = EntryPointComponent<
	{},
	{},
	PlanTimelineEntryPointEntrypointProps,
	{}
>;

export const planTimelineEntryPoint: EntryPoint<PlanTimelineEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<PlanTimelineEntryPointComponent>(
			/* webpackChunkName: "async-plan-timeline-entrypoint" */ './PlanTimelineEntryPointRoot.tsx',
		),
		getPreloadProps: () => ({}),
	});
